import { createContext } from 'preact';
import { useContext } from 'preact/hooks';

/**
 * How a social login button should hand off to the provider.
 *
 * By default it navigates the whole page, which is right for the standalone /login and /signup
 * routes. Inside the Speedy Flow that would tear the modal down and lose whatever the visitor had
 * already chosen, so the flow supplies a handler that opens the provider in a tab and waits to be
 * told how it went.
 *
 * The handler returns false when it could not open a tab, so the button falls back to navigating.
 */
export type AuthPopupHandler = (url: string) => boolean;

export interface AuthPopupConfig {
  open: AuthPopupHandler;
  /**
   * Extra query params for the provider URL. The Speedy Flow uses it to carry the offer the
   * visitor picked, which is otherwise lost across the round trip — it lives in modal state, and
   * the provider brings them back on a fresh page load (ADR 0004).
   */
  params?: Record<string, string | undefined>;
}

const AuthPopupContext = createContext<AuthPopupConfig | undefined>(undefined);

export const AuthPopupProvider = AuthPopupContext.Provider;

export const useAuthPopup = () => useContext(AuthPopupContext);

export default AuthPopupContext;
